export default __webpack_public_path__ + "static/media/mp4.8f543844.svg";